import {Id} from "./mate-types";

export const getIdAsKey = (id: Id): string => {
  return Array.isArray(id) ? (id.length === 1 ? id[0] : JSON.stringify(id)) : id ?? "null";
};
